import request from '@/util/request'


export const trainRecordList = (data) => request.post('/api/trainRecordList', data);  //培训档案列表

export const trainRecordAdd = (data) => request.post('/api/trainRecordAdd', data);  //培训档案添加

export const trainRecordEdit = (data) => request.post('/api/trainRecordEdit', data);  //培训档案编辑

export const trainRecordDel = (data) => request.post('/api/trainRecordDel', data);  //培训档案删除

export const trainRecordDetail = (data) => request.post('/api/trainRecordDetail', data);  //培训档案详情

export const trainRecordRequirementsAdd = (data) => request.post('/api/trainRecordRequirementsAdd', data);  //添加项目到档案

export const trainRecordRequirementsEdit = (data) => request.post('/api/trainRecordRequirementsEdit', data);  //编辑档案训练项目

export const trainRecordRequirementsDel = (data) => request.post('/api/trainRecordRequirementsDel', data);  //删除档案训练项目

export const trainRecordAddUser = (data) => request.post('/api/trainRecordAddUser', data);  //档案分配用户

export const trainRecordDelUser = (data) => request.post('/api/trainRecordDelUser', data);  //档案删除用户

export const trainAssignedCancel = (data) => request.post('/api/trainAssignedCancel', data);  //取消自行完成培训的指派

export const trainEditEndtime = (data) => request.post('/api/trainEditEndtime', data);  //修改培训截止日期

export const trainEditCertificationEndtime = (data) => request.post('/api/trainEditCertificationEndtime', data);  //修改培训认证截止日期

export const trainCompleteDetail = (data) => request.post('/api/trainCompleteDetail', data);  //标记培训完成详情

export const trainComplete = (data) => request.post('/api/trainComplete', data);  //标记培训完成

export const trainAssigned = (data) => request.post('/api/trainAssigned', data);  //指派用户完成自身培训

export const trainRecordCertificationDetail = (data) => request.post('/api/trainRecordCertificationDetail', data);  //标记认证进度详情

export const trainRecordCertification = (data) => request.post('/api/trainRecordCertification', data);  //记录认证进度

export const trainCertificationComplete = (data) => request.post('/api/trainCertificationComplete', data);  //标记认证完成